import { createCompaignBatches } from '@/features/material/redux/slice';
import { Modal, Table, Select, message } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const SequenceModal = ({
  visible,
  batches,
  onCancel,
  onSuccessFulSequenceUpdation
}) => {
  const [sequences, setSequences] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (batches && batches.length > 0) {
      setSequences(
        batches?.map((batch, idx) => {
          return {
            batchId: batch?.id,
            sequence: idx + 1,
            pbn: batch?.product_batch_number
          };
        })
      );
    }
  }, [batches]);

  const handleChange = (value, batchId) => {
    setSequences((prev) =>
      prev?.map((item) =>
        item.batchId === batchId ? { ...item, sequence: value } : item
      )
    );
  };

  const handleUpdateSequence = async () => {
    // Check for unique sequence numbers
    const sequenceNumbers = sequences.map((seq) => seq.sequence);
    const uniqueSequences = new Set(sequenceNumbers);
    if (uniqueSequences.size !== sequenceNumbers.length) {
      message.error(
        'Few batches have the same sequence number. Please ensure all are unique.'
      );
    } else {
      const payload = {
        get_compaign_batches: sequences.map((seq) => ({
          dispensing_request_id: seq.batchId,
          compaign_sequence: seq.sequence.toString()
        }))
      };

      const result = await dispatch(createCompaignBatches(payload));

      if (result?.payload?.success) {
        /*closing this modal and open the Assay Calculation View */
        onSuccessFulSequenceUpdation(result?.payload?.data);
      }
    }
  };

  const options = Array.from({ length: batches.length }, (_, i) => ({
    value: i + 1,
    label: i + 1
  }));

  const columns = [
    {
      title: 'Batch',
      dataIndex: 'pbn',
      key: 'batch'
    },
    {
      title: 'Sequence',
      dataIndex: 'sequence',
      key: 'sequence',
      render: (text, record) => (
        <Select
          value={record.sequence}
          style={{ width: 100 }}
          options={options}
          onChange={(value) => handleChange(value, record.batchId)}
        />
      )
    }
  ];

  return (
    <Modal
      title="Select Batch Sequence"
      visible={visible}
      onOk={handleUpdateSequence}
      onCancel={onCancel}
      okText="Update Sequence"
    >
      <Table
        dataSource={sequences}
        columns={columns}
        rowKey="batchId"
        pagination={false}
      />
    </Modal>
  );
};

export default SequenceModal;
